import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  modalMsg: { type: "", msg: "" },
  errorCode: "",
  checkPasswordPending: false,
  checkPasswordSuccess: false,
  checkPasswordFailure: false,
  inquiryAddPending: false,
  inquiryAddSuccess: false,
  inquiryAddFailure: false,
  inquiryList: {},
  inquiryListPending: false,
  inquiryListSuccess: false,
  inquiryListFailure: false,
  userInfo: {},
  changeUserPasswordPending: false,
  changeUserPasswordSuccess: false,
  changeUserPasswordFailure: false,
  changeUserEmailPending: false,
  changeUserEmailSuccess: false,
  changeUserEmailFailure: true,
  changeUserNamePending: false,
  changeUserNameSuccess: false,
  changeUserNameFailure: true,
  changeUserPhonePending: false,
  changeUserPhoneSuccess: false,
  changeUserPhoneFailure: true,
  myPointHistory: {},
  myPointHistoryPending: false,
  myPointHistorySuccess: false,
  myPointHistoryFailure: false,
  myExpirationPoint: {},
  myExpirationPointPending: false,
  myExpirationPointSuccess: false,
  myExpirationPointFailure: false,
  userSetting: {},
  userSettingPending: false,
  userSettingSuccess: false,
  userSettingFailure: false,
  userSettingUpdatePending: false,
  userSettingUpdateSuccess: false,
  userSettingUpdateFailure: false,
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    showMsg: (state, payload) => {
      state.modalMsg = {
        msg: payload.payload.msg,
        type: payload.payload.type,
      };
    },

    //checkPasswordSuccess 값 리셋(true or false)
    fetchInitCheckPassword: (state, payload) => {
      // console.log(payload.payload);
      state.checkPasswordSuccess = payload.payload;
    },
    // **마이페이지 진입시 패스워드 체크 **
    fetchCheckPassword: (state) => {
      state.checkPasswordPending = true;
      state.checkPasswordSuccess = false;
      state.checkPasswordFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchCheckPasswordSuccess: (state, { payload }) => {
      state.checkPasswordPending = false;
      state.checkPasswordSuccess = true;
      state.checkPasswordFailure = false;
    },
    fetchCheckPasswordFailure: (state, { payload }) => {
      state.checkPasswordPending = false;
      state.checkPasswordSuccess = false;
      state.checkPasswordFailure = true;
      state.modalMsg = {
        type: "",
        msg: "비밀번호를 확인해주세요.",
      };
    },

    // **1:1 문의하기 등록 **
    fetchInquiryAdd: (state) => {
      state.inquiryAddPending = true;
      state.inquiryAddSuccess = false;
      state.inquiryAddFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchInquiryAddSuccess: (state, { payload }) => {
      state.inquiryAddPending = false;
      state.inquiryAddSuccess = true;
      state.inquiryAddFailure = false;
      state.modalMsg = {
        type: "",
        msg: "등록되었습니다.",
      };
    },
    fetchInquiryAddFailure: (state, { payload }) => {
      state.inquiryAddPending = false;
      state.inquiryAddSuccess = false;
      state.inquiryAddFailure = true;
    },

    // **1:1 문의내역 **
    fetchInquiryList: (state) => {
      state.inquiryListPending = true;
      state.inquiryListSuccess = false;
      state.inquiryListFailure = false;
    },
    fetchInquiryListSuccess: (state, { payload }) => {
      state.inquiryList = payload.data.params;
      state.inquiryListPending = false;
      state.inquiryListSuccess = false;
      state.inquiryListFailure = false;
    },
    fetchInquiryListFailure: (state, { payload }) => {
      state.inquiryListPending = false;
      state.inquiryListSuccess = false;
      state.inquiryListFailure = true;
    },

    //유저 정보 조회
    fetchUserLookup: (state) => {},
    fetchUserLookupSuccess: (state, { payload }) => {
      state.userInfo = payload.data.params;
      state.changeUserEmailSuccess = false;
    },
    fetchUserLookupFailure: (state, { payload }) => {
      state.userInfo = "";
    },

    // **비밀번호 변경 **
    fetchChangeUserPassword: (state) => {
      state.changeUserPasswordPending = true;
      state.changeUserPasswordSuccess = false;
      state.changeUserPasswordFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchChangeUserPasswordSuccess: (state, { payload }) => {
      state.changeUserPasswordPending = false;
      state.changeUserPasswordSuccess = true;
      state.changeUserPasswordFailure = false;
    },
    fetchChangeUserPasswordFailure: (state, { payload }) => {
      state.changeUserPasswordPending = false;
      state.changeUserPasswordSuccess = false;
      state.changeUserPasswordFailure = true;
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
    },

    // **이메일 변경(요청)**
    fetchChangeUserEmail: (state) => {
      state.changeUserEmailPending = true;
      state.changeUserEmailSuccess = false;
      state.changeUserEmailFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchChangeUserEmailSuccess: (state, { payload }) => {
      state.changeUserEmailPending = false;
      state.changeUserEmailSuccess = true;
      state.changeUserEmailFailure = false;
      state.modalMsg = {
        type: "",
        msg: "전송되었습니다.",
      };
    },
    fetchChangeUserEmailFailure: (state, { payload }) => {
      state.changeUserEmailPending = false;
      state.changeUserEmailSuccess = false;
      state.changeUserEmailFailure = true;
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
    },

    // **이름 변경 **
    fetchChangeUserName: (state) => {
      state.changeUserNamePending = true;
      state.changeUserNameSuccess = false;
      state.changeUserNameFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchChangeUserNameSuccess: (state, { payload }) => {
      state.changeUserNamePending = false;
      state.changeUserNameSuccess = true;
      state.changeUserNameFailure = false;
      state.modalMsg = {
        type: "",
        msg: "회원정보가 수정되었습니다.",
      };
    },
    fetchChangeUserNameFailure: (state, { payload }) => {
      state.changeUserNamePending = false;
      state.changeUserNameSuccess = false;
      state.changeUserNameFailure = true;
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
    },

    // **핸드폰번호 변경 **
    fetchChangeUserPhone: (state) => {
      state.changeUserPhonePending = true;
      state.changeUserPhoneSuccess = false;
      state.changeUserPhoneFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchChangeUserPhoneSuccess: (state, { payload }) => {
      state.changeUserPhonePending = false;
      state.changeUserPhoneSuccess = true;
      state.changeUserPhoneFailure = false;
      state.modalMsg = {
        type: "",
        msg: "회원정보가 수정되었습니다.",
      };
    },
    fetchChangeUserPhoneFailure: (state, { payload }) => {
      state.changeUserPhonePending = false;
      state.changeUserPhoneSuccess = false;
      state.changeUserPhoneFailure = true;
      state.modalMsg = {
        type: "",
        msg: payload.response.data.message,
      };
    },

    // **나의 포인트 거래내역 **
    fetchMyPointHistory: (state) => {
      state.myPointHistoryPending = true;
      state.myPointHistorySuccess = false;
      state.myPointHistoryFailure = false;
    },
    fetchMyPointHistorySuccess: (state, { payload }) => {
      state.myPointHistoryPending = false;
      state.myPointHistorySuccess = true;
      state.myPointHistoryFailure = false;
      state.myPointHistory = payload.data.params;
    },
    fetchMyPointHistoryFailure: (state, { payload }) => {
      state.myPointHistoryPending = false;
      state.myPointHistorySuccess = false;
      state.myPointHistoryFailure = true;
    },

    // **나의 소멸예정 포인트 **
    fetchMyExpirationPoint: (state) => {
      state.myExpirationPointPending = true;
      state.myExpirationPointSuccess = false;
      state.myExpirationPointFailure = false;
    },
    fetchMyExpirationPointSuccess: (state, { payload }) => {
      state.myExpirationPointPending = false;
      state.myExpirationPointSuccess = true;
      state.myExpirationPointFailure = false;
      state.myExpirationPoint = payload.data.params;
    },
    fetchMyExpirationPointFailure: (state, { payload }) => {
      state.myExpirationPointPending = false;
      state.myExpirationPointSuccess = false;
      state.myExpirationPointFailure = true;
    },

    // **회원 설정 조회**
    fetchUserSetting: (state) => {
      state.userSettingPending = true;
      state.userSettingSuccess = false;
      state.userSettingFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchUserSettingSuccess: (state, { payload }) => {
      state.userSettingPending = false;
      state.userSettingSuccess = true;
      state.userSettingFailure = false;
      state.userSetting = payload.data.params;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchUserSettingFailure: (state, { payload }) => {
      state.userSettingPending = false;
      state.userSettingSuccess = false;
      state.userSettingFailure = true;
    },

    // **회원 설정 **
    fetchUserSettingUpdate: (state) => {
      state.userSettingUpdatePending = true;
      state.userSettingUpdateSuccess = false;
      state.userSettingUpdateFailure = false;
      state.modalMsg = {
        type: "",
        msg: "",
      };
    },
    fetchUserSettingUpdateSuccess: (state, { payload }) => {
      state.userSettingUpdatePending = false;
      state.userSettingUpdateSuccess = true;
      state.userSettingUpdateFailure = false;
      state.modalMsg = {
        type: "",
        msg: "변경되었습니다.",
      };
    },
    fetchUserSettingUpdateFailure: (state, { payload }) => {
      state.userSettingUpdatePending = false;
      state.userSettingUpdateSuccess = false;
      state.userSettingUpdateFailure = true;
      state.modalMsg = {
        type: "",
        msg: "변경 실패했습니다.",
      };
    },
  },
});

// 정의한 액션과 리듀서를 export한다.
export const userActions = userSlice.actions;
export default userSlice;
